// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__38Pma","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__1tNQy"};